// extracted by mini-css-extract-plugin
module.exports = {"root":"QuizEcap_root__KYrPR","container":"QuizEcap_container__Q9jDL","img":"QuizEcap_img__XZkY8","close_button":"QuizEcap_close_button__dYZGJ"};